import { Component, input } from '@angular/core';
import { RectDisplayStylePipe } from './rect-display-style.pipe';
import { NgClass, NgStyle } from '@angular/common';
import { ScaleRectPipe } from './scale-rect.pipe';
import { Dimension2d, WordRect } from '../model';

@Component({
  selector: 'shared-dp-overlay-rect',
  imports: [RectDisplayStylePipe, NgClass, NgStyle, ScaleRectPipe],
  templateUrl: './overlay-rect.component.html',
})
export class OverlayRectComponent {
  readonly rect = input.required<WordRect>();
  readonly dimension = input.required<Dimension2d>();
  readonly styleClasses = input<string>('bg-gray-700 border');
}
